export const LockIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="100"
      viewBox="0 0 80 100"
      fill="none"
      {...props}
    >
      <path
        d="M50 26C50 20.4772 45.5228 16 40 16C34.4772 16 30 20.4772 30 26V36C30 41.5228 34.4772 46 40 46C45.5228 46 50 41.5228 50 36V26Z"
        stroke="#A0522D"
        strokeWidth="5"
      />
      <path
        d="M15 59C15 72.8071 26.1929 84 40 84C53.8071 84 65 72.8071 65 59C65 45.1929 53.8071 34 40 34C26.1929 34 15 45.1929 15 59Z"
        fill="#FFAB53"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.2716 60.6232C45.0226 59.6799 47 57.0709 47 54C47 50.134 43.866 47 40 47C36.134 47 33 50.134 33 54C33 57.0709 34.9774 59.6799 37.7284 60.6232L35.6699 70.25H44.3301L42.2716 60.6232Z"
        fill="black"
      />
    </svg>
  );
};
